import dayjs from 'dayjs'

const config = {
  rowSelection: false,
  search: false,
  scroll: {
    y: 'calc(100vh - 510px)',
  },
  columns: [
    {
      title: '线索ID',
      dataIndex: 'clueId',
      width: 180,
      render: 'clueIdRender'
    },
    {
      title: '营销员',
      dataIndex: 'tenantName',
      width: 120,
      render: (text: string) => text || '-',
    },
    {
      title: '通话时长',
      dataIndex: 'callTimeLength',
      width: 150,
      render: (text: string) => text || '-',
    },
    {
      title: 'IP归属地',
      dataIndex: 'address',
      width: 150,
      render: (text: string) => text || '-',
    },
    {
      title: '是否合格',
      dataIndex: 'conformity',
      width: 150,
      render: (text: string) => text || '-',
    },
    {
      title: '呼叫时间',
      dataIndex: 'ring',
      itemType: 'dateTime',
      width: 180,
      render: (text: string) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      title: '呼叫类型',
      dataIndex: 'callTypeName',
      width: 150,
      render: (text: string) => text || '-',
    },
    {
      title: '接听状态',
      dataIndex: 'callStateName',
      width: 150,
      render: (text: string) => text || '-',
    },
    {
      title: '操作',
      dataIndex: 'bindType',
      width: 100,
      render: 'operation',
      fixed: 'right'
    }
  ],
  footer: false,
}

export default config
